// v63 — Bot Detection follows "Show Bot Check to clients" (admins: their own Bot Check view).
// v88 — loaded through accessLoader: a failed check is retried, never read as "no access".
import { makeAccess } from "@/lib/accessLoader";

const BD = makeAccess("bd", "/bot-detection/access", (d) => ({ enabled: !!d?.enabled, likeClients: !!d?.like_clients, show: d?.show || [] }));
// v69 — the admin switch grid calls this after a change, so the nav and page update at once.
export const resetBotDetectionAccess = BD.reset;

export function useBotDetectionAccess() {
  const { value, ready } = BD.useAccess();
  // v84 — per-team sections: Bot Meter and Flagged creators
  return { enabled: value.enabled, likeClients: value.likeClients, meter: value.show.includes("meter"), flagged: value.show.includes("flagged"), ready };
}
